import { graphql, useStaticQuery } from "gatsby"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import React from "react"

const Team = () => {
  const query = graphql`
    {
      allStrapiTeams {
        nodes {
          id
          name
          description
          role
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED)
              }
            }
          }
        }
      }
    }
  `

  const data = useStaticQuery(query)
  const { allStrapiTeams: nodes } = data
  return (
    <>
      {nodes.nodes.map((item, index) => {
        const path = getImage(item.image.localFile)
        return (
          <div className="col-12 col-sm-6 col-md-4 my-lg-5 my-4" key={index}>
            <div className="box-cont team">
              <GatsbyImage image={path} alt="Avatar" className="image" />
              <div className="overlay">
                <p className="overlay-heading mt-3">{item.name}</p>
                <p className="overlay-text second-para">{item.role}</p>
                <p className="overlay-text-sm second-para">
                  {item.description}
                </p>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export default Team
